import {
  ChangeDetectionStrategy,
  Component,
  inject,
} from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';
import { AuthService, STAFF_ROLES } from '@nebalkon-workspace/auth';
import { LocalStorageMobileKeys } from '../entities/enum/local-storage-mobile-keys.enum';

/** Placeholder for `''` route; real navigation is via initialRedirectGuard (NG04014). */
@Component({
  selector: 'app-root-redirect',
  template: '',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RootRedirectComponent {}

/**
 * Root path: onboarding → auth (if not authenticated) → staff roles → /stuff, otherwise → /client.
 * Implemented as CanMatch (not redirectTo + function) so inject(AuthService) runs in an injection context.
 * Roles come from AuthService.roles() (JWT until profile loads, then GET /profile).
 */
export const initialRedirectGuard: CanMatchFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  const onboardingSeen =
    localStorage.getItem(LocalStorageMobileKeys.OnboardingSeen) === 'true';

  if (!onboardingSeen) {
    return router.createUrlTree(['/onboarding']);
  }

  if (!authService.isAuthenticated()) {
    return router.createUrlTree(['/auth']);
  }

  const userRoles = authService.roles();

  if (userRoles.some((role) => STAFF_ROLES.includes(role))) {
    return router.createUrlTree(['/stuff']);
  }

  return router.createUrlTree(['/client']);
};
